import {Component, Inject, OnInit} from '@angular/core';
import {MAT_DIALOG_DATA, MatDialogRef} from '@angular/material/dialog';
import {FormControl, FormGroup, Validators} from '@angular/forms';
import {select, Store} from '@ngrx/store';
import {ProjektState} from '../../store/reducer/projektverwaltung.reducer';
import {Observable} from 'rxjs';
import * as moment from 'moment';
import {editMitarbeiterStart} from '../../../Mitarbeiterverwaltung/store/actions/mitarbeiter-edit.actions';
import {addMitarbeiterStart} from '../../../Mitarbeiterverwaltung/store/actions/mitarbeiter-add.actions';
import {addProjektStart} from '../../store/actions/projekt-add.actions';
import {editProjektStart} from '../../store/actions/projekt-edit.actions';
import {loadAllMitarbeiterStart} from '../../../Mitarbeiterverwaltung/store/actions/getAllMitarbeiter.actions';
import {AnredeItem} from '../../../Mitarbeiterverwaltung/anrede.model';
import {MitarbeiterItem} from '../../../Mitarbeiterverwaltung/mitarbeiter.model';
import {State} from '../../../Mitarbeiterverwaltung/store/reducer/mitarbeiterverwaltung.reducer';
import {editProjektstufeStart} from '../../store/actions/projektstufe-edit.actions';
import {addProjektstufeStart} from '../../store/actions/projektstufe-add.actions';

export interface DialogData{
  title: string;
  submitButtonLabel: string;
  cancelButtonLabel: string;
  id: number;
  prjprj: number;
  nummer: string;
  name: string;
  level: number;
  mitarbeiter: MitarbeiterItem[];
}

@Component({
  selector: 'app-projektstufe-formdialog',
  templateUrl: './projektstufe-formdialog.component.html',
  styleUrls: ['./projektstufe-formdialog.component.scss']
})

export class ProjektStufeFormdialogComponent implements OnInit {

  public $mitarbeiter: Observable<MitarbeiterItem[]>;

  constructor(
    public dialogRef: MatDialogRef<ProjektStufeFormdialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: DialogData,
    private mitarbeiter: Store<{ mitarbeiterverwaltung: State }>,
    private store: Store<{ projektverwaltung: ProjektState }>) {
    dialogRef.disableClose = true;
    this.$mitarbeiter = mitarbeiter.pipe(select((state) => state.mitarbeiterverwaltung.items));
    this.projektForm.patchValue({
      id: data.id,
      name: data.name,
      nummer: data.nummer,
      mitarbeiter: data.mitarbeiter,
      prjprj: data.prjprj,
      level: data.level,
    });
  }

  public projektForm = new FormGroup({
    name: new FormControl('', [Validators.required, Validators.maxLength(255)]),
    nummer: new FormControl('', [Validators.maxLength(255), Validators.pattern('^[0-9.]*$')]),
    mitarbeiter: new FormControl(''),
    id: new FormControl(''),
    level: new FormControl(''),
    prjprj: new FormControl(''),
    });


  public handleSubmitClick(): void{
    const item = this.projektForm.value;
    // Mitgeben von der ProjektId des Parents und dem Level des Parents +1 = Level des neu erstellten Kindes
    item.prjprj = this.data.prjprj;
    // tslint:disable-next-line:radix
    item.level = (parseInt(String(this.data.level)) + 1);
    // Projektstufen ausser 0 hier
    if(this.data.level){
      if (this.data.id) {
        this.store.dispatch(editProjektstufeStart({item}));
      } else {
        this.store.dispatch(addProjektstufeStart({item}));
      }
    }
    // Projektstufe 0 hier
    else{
      if (this.data.id) {
        this.store.dispatch(editProjektstufeStart({item}));
      } else {
        this.store.dispatch(addProjektstufeStart({item}));
      }
    }

    this.dialogRef.close(true);
  }

  public handleCancelClick(): void{
    this.dialogRef.close(true);
  }

  public getErrorMessage(formField: string): string {
    const formControl = this.projektForm.get(formField);
    if ( formControl.hasError('required')){
      return `pages.projektverwaltung.projektDialog.err.${formField}.pflichtfeld`;
    }
    else if ( formControl.hasError('maxlength')){
      return `pages.projektverwaltung.projektDialog.err.${formField}.maxlength`;
    }
    else if ( formControl.hasError('min')){
      return `pages.projektverwaltung.projektDialog.err.${formField}.min`;
    }
    else if ( formControl.hasError('pattern')){
      return `pages.projektverwaltung.projektDialog.err.${formField}.pattern`;
    }
    return 'pages.projektverwaltung.projektDialog.err.generic';
  }

  ngOnInit(): void {
    this.store.dispatch(loadAllMitarbeiterStart({string: sessionStorage.getItem('firmaId')}));
  }

}
